import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetRoles", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, payload) => {
  var roles = {
    data: [],
    meta: {},
  };

  await services.acl.get_all(payload).then((res) => {
    roles = res.data;
  });
  return roles;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.acl.show({ id: id }).then((res) => {
    dispatch("ActionSetRole", res.data.role);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.acl.store(payload).then((res) => {
    commit(types.SET_ROLE, res.data.role);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.acl.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_ROLE, res.data.role);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.acl.delete({ id: id }).then(() => {
    commit(types.SET_ROLE, null);
  });
};

export const ActionSetRoles = ({ commit }, payload) => {
  commit(types.SET_ROLES, payload);
};

export const ActionSetRole = ({ commit }, payload) => {
  commit(types.SET_ROLE, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewRole = ({ commit }) => {
  let role = {
    name: "",
    permissions: [],
  };
  commit(types.SET_ROLE, role);
};

export const ActionLoadPermissions = async ({ dispatch }) => {
  let response = [];
  await services.acl.get_all_permissions().then((res) => {
    response = res.data.data;
  });
  return response;
};
